import React from 'react';
import { motion } from 'framer-motion';
import { Anchor, Package, ClipboardCheck, ArrowRight } from 'lucide-react';
const capabilities = [{
  title: 'Hull & Machinery',
  description: 'Condition surveys, damage assessment, engine & marine gear failure analysis, audio gauging, and new vessel construction attendance.',
  icon: Anchor
}, {
  title: 'Cargo & Appraisals',
  description: 'Cargo load, secure & damage surveys. Container condition surveys. Appraisals on inland/offshore boats, barges, heavy equipment & yachts.',
  icon: Package
}, {
  title: 'Audits & Consulting',
  description: 'AWO Responsible Carrier Program audits, American Chemistry Council Responsible Care audits, expert witness, mediation, and collaborative naval architect services.',
  icon: ClipboardCheck
}];
export function CapabilitiesSection() {
  return <section className="py-20 bg-offwhite relative z-10" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <span className="text-accent font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-29">
            What We Do
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy uppercase" data-id="element-30">
            Core Capabilities
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto mt-4" data-id="element-31"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-32">
          {capabilities.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-white p-8 shadow-md hover:shadow-xl transition-all duration-300 group border-t-4 border-transparent hover:border-accent transform hover:-translate-y-1" data-id="element-33">
              <div className="w-14 h-14 bg-navy/5 rounded-none flex items-center justify-center mb-6 group-hover:bg-accent transition-colors duration-300" data-id="element-34">
                <item.icon className="w-8 h-8 text-navy group-hover:text-white transition-colors duration-300" data-id="element-35" />
              </div>
              <h3 className="text-xl font-heading font-bold text-navy mb-4 uppercase" data-id="element-36">
                {item.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed min-h-[100px]" data-id="element-37">
                {item.description}
              </p>
              <a href="#services" className="inline-flex items-center text-accent font-bold uppercase text-sm tracking-wider hover:text-navy transition-colors" data-id="element-38">
                Learn More <ArrowRight className="ml-2 w-4 h-4" data-id="element-39" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}